import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Bell,
  BellRing,
  Package
} from 'lucide-react';
import { TriggeredAlertsList } from './TriggeredAlertsList';
import { ProductsWithAlertsList } from './ProductsWithAlertsList';

type SubTab = 'triggered' | 'products';

interface AlertsTabProps {
  currentTableName?: string;
  onProductClick?: (productId: string) => void;
}

export const AlertsTab: React.FC<AlertsTabProps> = ({
  currentTableName,
  onProductClick
}) => {
  const { t } = useTranslation();
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('triggered');

  const subTabs: { key: SubTab; label: string; icon: React.ReactNode }[] = [
    {
      key: 'triggered',
      label: t('alerts.triggered_alerts'),
      icon: <BellRing className="h-4 w-4" />
    },
    {
      key: 'products',
      label: t('alerts.products_with_alerts'),
      icon: <Package className="h-4 w-4" />
    }
  ];

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center space-x-3">
        <Bell className="h-6 w-6 text-blue-600" />
        <h2 className="text-xl font-semibold text-gray-900">{t('alerts.title')}</h2>
      </div>

      {/* Sub-tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex space-x-4">
          {subTabs.map(({ key, label, icon }) => (
            <button
              key={key}
              onClick={() => setActiveSubTab(key)}
              className={`flex items-center space-x-2 px-4 py-3 border-b-2 font-medium text-sm transition-colors ${
                activeSubTab === key
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {icon}
              <span>{label}</span>
            </button>
          ))}
        </nav>
      </div>

      {/* Contenido */}
      <div className="mt-4">
        {activeSubTab === 'triggered' && (
          <TriggeredAlertsList onProductClick={onProductClick} />
        )}
        {activeSubTab === 'products' && (
          <ProductsWithAlertsList
            currentTableName={currentTableName}
            onProductClick={onProductClick}
          />
        )}
      </div>
    </div>
  );
};
